module.exports = __webpack_public_path__ + "ssygl/img/zanwushuju.99f8d93b.png";